export default theme => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '100%',
      padding: '40px 90px',
      borderRadius: 20,
      background: theme.palette.MMColors.dark,
      color: theme.palette.MMColors.light,
      position: 'relative',
    },
  },
  dialogBig: {
    '& .MuiPaper-root': {
      maxWidth: 1396,
    },
  },
  dialogMedium: {
    '& .MuiPaper-root': {
      maxWidth: 1050,
    },
  },
  dialogSmall: {
    '& .MuiPaper-root': {
      maxWidth: 980,
    },
  },
  dialogTitle: {
    padding: 0,
    margin: '0 0 40px',
    textAlign: 'center',
  },
  dialogLabel: {
    margin: 0,
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: '0.86',
    letterSpacing: '0.14px',
    color: theme.palette.MMColors.light,
  },
  closeButton: {
    padding: 0,
    position: 'absolute',
    top: 20,
    right: 20,
    '& svg': {
      fill: theme.palette.MMColors.fox,
    },
  },
  dialogCont: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: 0,
  },
  styleHeightContainer: {
    height: '100%',
    maxHeight: 'calc(100% - 120px)',
  },
});
